import React, {useEffect, useState} from 'react';
import LicenseFormReviewTabs from "./licenseFormReviewTabs";
import LicenseFormReviewTable from "./licenseFormReviewTable";
import LicenseFormSelector from "./licenseFormSelector";
import './index.css';
import LicenseFormFooter from "./licenseFormFooter";
import auditDataStore from '../../stores/license/auditDataStore';
import {CircularProgress, Typography} from '@material-ui/core';

export const LicenseForms = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const forManager = true;
            await auditDataStore.fetchAuditData(forManager);
            setLoading(false);
        };
        fetchData();
        
        // Cleanup function to save state when component unmounts
        return () => {
            auditDataStore.saveToCache();
        };
    }, []);

    if (loading) {
        return <CircularProgress/>;
    }

    if (auditDataStore.fetchError) {
        return (
            <Typography variant="body1" color="error" gutterBottom>
                {auditDataStore.fetchError}
            </Typography>
        );
    }

    return (
        <div id="license-form-wrapper">
            <LicenseFormReviewTabs/>
            <LicenseFormSelector/>
            <LicenseFormReviewTable/>
            <LicenseFormFooter/>
        </div>
    );
};